module.exports = __webpack_public_path__ + "static/img/nodata@2x.e2e3f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/competition/nodata@2x.png
// module id = UYDS
// module chunks = 86